// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__32B9c","large":"styles_large__2j1tS"};